import { service } from ".";

export default {
  getAll: () => service.get("/ourteams"),
  getOne: (id) => service.get(`/ourteams/${id}`),
  getAllPaginate: (query) => service.get(`/ourteams/paginate?${query}`),
  create: (data) => service.post("/ourteams", data),
  update: (id, data) => service.put(`/ourteams/${id}`, data),
  delete: (id) => service.delete(`/ourteams/${id}`),
};
